module.exports = "/_next/static/images/0e9611358e12fead0b6b41c5bec2032a-apply-bullet-3.jpeg";